export function initCustomMenu() {
	const customMenuContainer = document.getElementById("custom-menu-container");
	if (!customMenuContainer) return;

	let items = [];
	try {
		items = JSON.parse(customMenuContainer.getAttribute("data-items") || "[]");
	} catch (e) {
		console.error("[MagicTools] Invalid custom menu JSON:", e);
		return;
	}

	const originalMenu = document.getElementById("menuItems");
	if (!originalMenu) return;

	// Cacher le contenu existant mais garder #menuItems visible,
	// sinon les règles CSS "#menuItems .displayed-nav-items" ne s'appliquent pas.
	Array.from(originalMenu.children).forEach(function (child) {
		child.style.display = "none";
	});

	const newMenu = document.createElement("ul");
	newMenu.className = "displayed-nav-items";
	newMenu.id = "displayed-nav-items";
	items.forEach((item) => {
		if (item.title && item.url) {
			const li = document.createElement("li");
			li.setAttribute("data-span", "3");
			const a = document.createElement("a");
			a.href = item.url;
			a.textContent = item.title;
			li.appendChild(a);

			const children = item.children || [];
			if (children.length > 0) {
				const submenu = document.createElement("ul");
				submenu.className = "br-custom-submenu";
				children.forEach((child) => {
					if (child.title && child.url) {
						const childLi = document.createElement("li");
						const childA = document.createElement("a");
						childA.href = child.url;
						childA.textContent = child.title;
						childLi.appendChild(childA);
						submenu.appendChild(childLi);
					}
				});
				if (submenu.children.length > 0) {
					li.appendChild(submenu);
				}
			}

			newMenu.appendChild(li);
		}
	});
	// Insérer DANS #menuItems pour que le scope CSS fonctionne
	originalMenu.appendChild(newMenu);
}
